import { UseMutationOptionsFromProvider, useMutationEndpoint } from '../../core'
import { postAccessManagementAccountPassword } from '../endpoints'

type EndpointParams = Parameters<typeof postAccessManagementAccountPassword>[0]
type HookParams = Pick<EndpointParams, 'apiVersion'>
type MutationVariables = Pick<EndpointParams, 'data'>

export const useAccessManagementAccountPasswordPostMutation = (
  { apiVersion }: HookParams,
  options?: UseMutationOptionsFromProvider<
    typeof postAccessManagementAccountPassword,
    MutationVariables
  >,
) =>
  useMutationEndpoint(
    ({ data }: MutationVariables) =>
      postAccessManagementAccountPassword({ apiVersion, data }),
    options,
  )
